/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetAvailableStampsRequest} from '@cash-web/protos/squareup/cash/whimsicard/api/v1/get_available_stamps.pb'
import {GetAvailableStampsResponse} from '@cash-web/protos/squareup/cash/whimsicard/api/v1/get_available_stamps.pb'


export const getAvailableStamps = (request: GetAvailableStampsRequest, options?: CashRequestOptions) => post<GetAvailableStampsRequest, GetAvailableStampsResponse>("/2.0/cash/get-available-stamps", request, {...options, rejectOnError: true })